import { CHANGE_PRIMARY, CHANGE_SECONDARY, CHANGE_URL} from './actionTypes'

export const changePrimary = (primary) => {
  return {
      type: CHANGE_PRIMARY,
      primary
  }
}

export const changeSecondary = (secondary) => {
  return {
      type: CHANGE_SECONDARY,
      secondary
  }
}

const getUrl = (color) => {
  switch(color) {
    case '#228B22':
      return 'https://bmc.xyz/l/gynPlitSh';
    case '#EE82EE':
      return 'https://bmc.xyz/l/KhdA8TRqk';
    case '#00BFFF':
      return 'https://bmc.xyz/l/aYtV08J6p';
    case '#dc143c':
      return "https://bmc.xyz/l/uiFBMvzHQ";
    case '#DAA520':
      return "https://bmc.xyz/l/vxtm7NzD8";
    case '#800080':
      return 'https://bmc.xyz/l/Y7CqkayTR';
    default: return '';
  }
}
export const changeUrl = (color) => {
  const url = getUrl(color);
  return {
      type: CHANGE_URL,
      url
  }
}
